import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-fahrzeug-list-view',
  imports: [],
  templateUrl: './fahrzeug.list-view.html',
  styleUrls: ['./fahrzeug.list-view.css'],
})
export class FahrzeugListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
